<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="cbp-spmenu-push">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="banner-info">
          <span>關於華胤</span>
        </div>
      </div>
    </div>
    <!-- banner-bottom -->
    <section>
      <!-- 公司簡介 -->
      <section id="lsyg">
        <div class="banner-bottom">
          <div class="onlyPC">
            <div class="col-lg-5 banner-bottom-left1">
              <div class="banner-bottom-left1-grid">
                <h3>華胤歷史沿革</h3>
                <div class="progress progress1">
                  <div
                    class="progress-bar progress-bar1"
                    role="progressbar"
                    aria-valuenow="40"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 40%"
                  >
                    <span class="sr-only">40% Complete</span>
                  </div>
                </div>
                <p>
                  華胤是在1994年由一群熟悉美日澳等鋼結構規範之工程師所創立,發展初期在中國大陸華南及華東地區協助眾多台資及外資企業提供鋼結構服務,服務過的客戶包括資通電子知名企業,如宏碁、金仁寶、南亞、台光電、威盛等企業,及半導體業界之台積電、三星電子、英特爾等公司。經過30年經驗積累,現有員工500多名,並將服務拓展到南北美洲、澳洲、歐洲等地區,產品出口超過30個國家,並累積完成超過4000個鋼結構工程項目,涵蓋生產工廠、物流、住宅商辦、公用建築、石化、能源電力、礦業金屬及高層大樓等產業。
                </p>
              </div>
            </div>
            <div class="col-lg-7 banner-bottom-left2">
              <div class="grid">
                <figure>
                  <img
                    src="@/components/img/gyhy/3.jpg"
                    alt=""
                    class="showImg"
                  />
                </figure>
              </div>
            </div>
          </div>

          <div class="clearfix"></div>
        </div>
      </section>

      <!-- 華胤目標 -->
      <section>
        <div id="hymb">
          <div class="banner-bottom1 visible-lg">
            <div class="onlyPC">
              <div class="col-lg-7 banner-bottom-left2 banner-bottom1-left2">
                <div class="grid">
                  <figure>
                    <img
                      src="@/components/img/gyhy/2.jpg"
                      alt=""
                      class="showImg"
                    />
                  </figure>
                </div>
              </div>
              <div class="col-lg-5 banner-bottom-lft1">
                <h4>華胤目標</h4>
                <div class="progress progress1 progress2">
                  <div
                    class="progress-bar progress-bar1"
                    role="progressbar"
                    aria-valuenow="40"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 40%"
                  >
                    <span class="sr-only">40% Complete</span>
                  </div>
                </div>
                <p>
                  華胤的企業目標是在運用我們多年累積之專業,提供高品質之鋼結構產品及經典工程項目服務,協助客戶建立成功基業。我們通過技術創新,專業設計及各種客戶導向之服務,來實現這一目標,確保我們在生產安全前提下,能堅守高品質承諾而又能準時交運產品及控制交期。
                </p>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
          <div class="banner-bottom1 hidden-lg">
            <div class="onlyPC">
              <div class="col-lg-5 banner-bottom-lft1">
                <h4>華胤目標</h4>
                <div class="progress progress1 progress2">
                  <div
                    class="progress-bar progress-bar1"
                    role="progressbar"
                    aria-valuenow="40"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 40%"
                  >
                    <span class="sr-only">40% Complete</span>
                  </div>
                </div>
                <p>
                  華胤的企業目標是在運用我們多年累積之專業,提供高品質之鋼結構產品及經典工程項目服務,協助客戶建立成功基業。我們通過技術創新,專業設計及各種客戶導向之服務,來實現這一目標,確保我們在生產安全前提下,能堅守高品質承諾而又能準時交運產品及控制交期。
                </p>
              </div>
              <div class="col-lg-7 banner-bottom-left2 banner-bottom1-left2">
                <div class="grid">
                  <figure>
                    <img
                      src="@/components/img/gyhy/2.jpg"
                      alt=""
                      class="showImg"
                    />
                  </figure>
                </div>
              </div>

              <div class="clearfix"></div>
            </div>
          </div>
        </div>

        <div class="banner-bottom1" id="hyyj">
          <div class="onlyPC">
            <div class="col-lg-5 banner-bottom-lft1">
              <h4>華胤願景</h4>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
              <p>
                華胤的願景是成為世界頂尖之鋼結構建築集團,透過不斷優化之工藝,並運用鋼結構建築在環保,經濟,安全,造型美觀及材料可回收再用之優勢,協助客戶建造可持續之經典工程項目,創造優質工作及生活環境。
              </p>
            </div>
            <div class="col-lg-7 banner-bottom-left2 banner-bottom1-left2">
              <div class="grid">
                <figure>
                  <img
                    src="@/components/img/gyhy/4.jpg"
                    alt=""
                    class="showImg"
                  />
                </figure>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </section>
      <!-- 工廠介紹 -->
      <section id="esg">
        <div class="container gradient-background">
          <!-- ESG -->
          <div class="row">
            <div class="col-lg-12 rzTop">
              <h1><span>ESG</span></h1>
              <p class="rzp">
                華胤集團於第三代海安工廠全面落實ESG策略,從建材選擇到能源配置,系統性導入低碳化與資源循環概念。廠房主體鋼構大幅採用自第二代昆山廠拆卸回收之構件,充分展現鋼結構模組化、可重複利用的永續特性,顯著降低新材料使用與建設階段碳排放。
              </p>
              <p class="rzp">
                能源方面,海安廠屋頂搭載由集團旗下國盛新能源（GS Solar
                Power）建置之太陽能發電系統,現已穩定供應超過50%廠區用電,實質提升再生能源使用占比,強化營運韌性。此外,工廠導入業界極少數採用、造價高昂的水幕移動式環保噴漆房,可有效減少約50%碳排放與70%揮發性有機物排放,不僅優化作業環境,更體現華胤對環保細節的高度投入與執行力。
              </p>
              <p class="rzp">
                華胤已取得ISO 14001環境管理與ISO
                45001職業安全衛生雙國際認證,並符合歐盟EN1090鋼構製造與ISO
                3834焊接品質標準。以高標準治理體系為基礎,華胤持續推進企業永續責任與綠色製造實踐,致力成為鋼構產業中值得信賴的ESG實踐者。
              </p>
            </div>
            <div class="col-lg-12 esgImgCon">
              <img src="@/components/img/gyhy/esg.png" alt="" class="esgImg" />
            </div>
          </div>

          <!-- 工廠介紹 -->
          <div class="row" id="gcjs">
            <div class="col-lg-12 rzTop">
              <h1><span>工廠介紹</span></h1>
              <p>
                華胤集團已在亞洲地區建置多座專業鋼結構生產工廠,可因應各地客戶需求或項目特點來調度供應,提高營建施工效率。其中華胤集團位於江蘇海安之工廠佔地面積12.5萬平方米,廠房面積達6.3萬平方米,年產能可達5萬噸鋼構件及3萬噸彩鋼成型構件。該廠採用先進自動化加工設備及符合最新環保規定之塗裝設備,亦可承接重鋼構件業務。公司秉承創辦以來的核心價值-持續創新,改善質量,誠信服務-信念,以高度執行力持續為客戶提供優質服務。
              </p>
              <div class="spaceCon">
                <div
                  class="col-lg-3 col-xs-6"
                  v-for="(item, index) in gcjsList"
                  :key="index"
                >
                  <div class="gcjsImg">
                    <img
                      v-lazy="item.image[0]"
                      alt=""
                      style="width: 100%; height: 100%"
                      :key="index"
                    />
                  </div>
                  <div class="gcjsp gcjsHeight" style="white-space: pre-line">
                    <p>{{ item.text }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 認證獎項 -->
          <div class="row" id="rzjx">
            <div class="col-lg-12 rzTop">
              <h1><span>華胤集團國際認證&建築獎項</span></h1>
              <p>
                華胤擁有鋼結構相關領域{{
                  zzzsList.length
                }}項專業認證,包括美國鋼結構協(AISC)認證,美國焊接會(AWS)認證,加拿大焊接局(CWB),日本鋼構評估檢驗協會(JSA),歐洲ISO品質管理系統等。透過每一次認證申請或年度更新查核我們得以讓自己品質系統運作更加順暢並藉機向國際認證機構品質專家學習成長,這些努力反映了我們對作好品質管理之堅持及走向國際高端市場之決心。
              </p>
              <p>
                華胤自創立以來即不斷努力提升產品品質及工程項目服務水準,多次獲得政府及專業機構表揚,在承接國際知名工程總包商之經典項目時也屢獲客戶肯定,獲頒優良供應商獎勵,團隊克服困難推進項目之執行力,也多次獲得業主及工程總包商致函感謝。華胤在建築工程領域也持續茁壯,連年屢獲金鋼獎,十大影響力品牌,十大傑出企業共32項獎項之肯定。
              </p>
            </div>
          </div>

          <!-- 國際認證 -->
          <div>
            <h2>
              <span class="hspan"
                ><span style="color: red">///////// </span>國際認證</span
              >
            </h2>
          </div>
          <div class="container-fluid">
            <div
              class="col-lg-4 col-xs-6"
              v-for="(item, index) in zzzsList"
              :key="index"
            >
              <div class="portfolio-item">
                <div class="thumb">
                  <div class="image">
                    <div class="demo-image__preview gjrzImg">
                      <el-image
                        lazy
                        style="height: 100%"
                        :src="item.image[0]"
                        :preview-src-list="item.image"
                        fit="contain"
                      >
                        <div slot="placeholder">
                          <img src="@/components/img/loading.gif" alt="" />
                        </div>
                        <div slot="error">
                          <img src="@/components/img/error.gif" alt="" />
                        </div>
                      </el-image>
                    </div>
                  </div>
                  <div class="hover-effect">
                    <div
                      class="hover-content zzzsHeight"
                      style="white-space: pre-line"
                    >
                      <h1>{{ item.text }}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 建築獎項 -->
          <div>
            <h2>
              <span class="hspan"
                ><span style="color: red">///////// </span>建築獎項</span
              >
            </h2>
          </div>
          <div class="container-fluid">
            <div
              class="col-lg-1-5 col-xs-4"
              v-for="(item, index) in jzjxList"
              :key="index"
            >
              <div class="portfolio-item">
                <div class="thumb">
                  <div class="image">
                    <div class="demo-image__preview jzjxImg">
                      <el-image
                        style="height: 100%"
                        :src="item.image[0]"
                        :preview-src-list="item.image"
                        lazy
                      >
                        <div slot="placeholder">
                          <img src="@/components/img/loading.gif" alt="" />
                        </div>
                        <div slot="error">
                          <img src="@/components/img/error.gif" alt="" />
                        </div>
                      </el-image>
                    </div>
                  </div>
                  <div class="hover-effect">
                    <div
                      class="hover-content jzjxHeight"
                      style="white-space: pre-line"
                    >
                      <h1>{{ item.text }}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 感謝狀 -->
          <div>
            <h2>
              <span class="hspan2"
                ><span style="color: red">///////// </span>工程感謝狀 |
                獎盃</span
              >
            </h2>
          </div>
          <div class="container-fluid">
            <div
              class="col-lg-1-5 col-xs-4"
              v-for="(item, index) in gxzList"
              :key="index"
            >
              <div class="portfolio-item">
                <div class="thumb">
                  <div class="image">
                    <div class="demo-image__preview jzjxImg">
                      <el-image
                        lazy
                        style="height: 100%"
                        :src="item.image[0]"
                        :preview-src-list="item.image"
                      >
                        <div slot="placeholder">
                          <img src="@/components/img/loading.gif" alt="" />
                        </div>
                        <div slot="error">
                          <img src="@/components/img/error.gif" alt="" />
                        </div>
                      </el-image>
                    </div>
                  </div>
                  <div class="hover-effect">
                    <div
                      class="hover-content jzjxHeight"
                      style="white-space: pre-line"
                    >
                      <h1>{{ item.text }}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 小滾輪 -->
      <div id="ss_menu">
        <div>
          <i
            ><a @click="forId('lsyg')">歷史<br />沿革</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('hymb')">華胤<br />目標</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('hyyj')">華胤<br />願景</a></i
          >
        </div>
        <div>
          <i><a @click="forId('esg')">ESG</a></i>
        </div>
        <div>
          <i
            ><a @click="forId('gcjs')">工廠<br />介紹</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('rzjx')">認證<br />獎項</a></i
          >
        </div>
        <div class="menu">
          <div class="share" id="ss_toggle" data-rot="180">
            <div class="circle"></div>
            <div class="bar"></div>
          </div>
        </div>
      </div>
    </section>
    <div class="mailbg">
      <to-mail button-text="聯絡我們"></to-mail>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gcjsList: [
        {
          image: [require('@/components/img/gyhy/gcjs1.png')],
          text: '生產車間\n面積49,000平米',
        },
        {
          image: [require('@/components/img/gyhy/gcjs2.png')],
          text: '塗裝車間\n面積10,000平米',
        },
        {
          image: [require('@/components/img/gyhy/gcjs3.png')],
          text: '成品堆場\n面積15,000平米',
        },
        {
          image: [require('@/components/img/gyhy/gcjs4.png')],
          text: '最大單件起重量\n40噸',
        },
        {
          image: [require('@/components/img/gyhy/gcjs5.png')],
          text: '塗裝車間\n空氣淨化設備',
        },
        {
          image: [require('@/components/img/gyhy/gcjs6.png')],
          text: '12,000W\n雷射平面切割機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs7.png')],
          text: 'H型鋼三維五軸\n雷射切割機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs8.png')],
          text: '自動相貫線切割機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs9.png')],
          text: '等離子型材切割機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs10.png')],
          text: '多門火焰切割機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs11.png')],
          text: '20,000W\n雷射平面切割機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs12.png')],
          text: '等離子火焰\n數控平面切割機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs21.png')],
          text: '型鋼雷射切割機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs13.png')],
          text: '環保噴漆房',
        },
        {
          image: [require('@/components/img/gyhy/gcjs14.png')],
          text: '噴砂機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs15.png')],
          text: '機器人焊接',
        },
        {
          image: [require('@/components/img/gyhy/gcjs16.png')],
          text: 'SAW焊機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs17.png')],
          text: '電渣焊',
        },
        {
          image: [require('@/components/img/gyhy/gcjs18.png')],
          text: '高速七軸三維鑽床',
        },
        {
          image: [require('@/components/img/gyhy/gcjs19.png')],
          text: 'CNC數控鑽床',
        },
        {
          image: [require('@/components/img/gyhy/gcjs22.png')],
          text: 'CNC端面銑床',
        },
        {
          image: [require('@/components/img/gyhy/gcjs20.png')],
          text: '組立機',
        },
      ],
      zzzsList: [
        {
          image: [require('@/components/img/gyhy/zzzs5.png')],
          text: '美國鋼結構協會\nAISC',
        },
        {
          image: [require('@/components/img/gyhy/zzzs8.png')],
          text: '美國焊接協會\nAWS',
        },
        {
          image: [require('@/components/img/gyhy/zzzs6.png')],
          text: '加拿大焊接協會\nCWB\nCSA W47.1',
        },
        {
          image: [require('@/components/img/gyhy/zzzs9.png')],
          text: '中國鋼鐵\n一級資質',
        },
        {
          image: [require('@/components/img/gyhy/zzzs10-1.png')],
          text: '歐盟鋼結構品質標準\nEN1090-1',
        },
        {
          image: [require('@/components/img/gyhy/zzzs10-2.png')],
          text: '歐盟鋼結構品質標準\nEN1090-2',
        },
        {
          image: [
            require('@/components/img/gyhy/zzzs14.png'),
            require('@/components/img/gyhy/zzzs15.png'),
          ],
          text: '日本國土交通省認定鐵骨制作\n JSA',
        },
        {
          image: [
            require('@/components/img/gyhy/zzzs13.png'),
            require('@/components/img/gyhy/zzzs12.png'),
          ],
          text: '歐盟建設工程鋼結構設計生產\nISO 9001',
        },
        {
          image: [
            require('@/components/img/gyhy/zzzsen2.png'),
            require('@/components/img/gyhy/zzzs2.png'),
            require('@/components/img/gyhy/zzzs4.png'),
          ],
          text: '歐盟職業安全管理\nISO 45001',
        },
        {
          image: [
            require('@/components/img/gyhy/zzzsen1.png'),
            require('@/components/img/gyhy/zzzs1.png'),
            require('@/components/img/gyhy/zzzs3.png'),
          ],
          text: '歐盟環境管理系統\nISO 14001',
        },
        {
          image: [require('@/components/img/gyhy/zzzs11.png')],
          text: '國際焊接質量控制標準體系\nISO 3834',
        },
        {
          image: [require('@/components/img/gyhy/zzzs16.png')],
          text: '加拿大鋼構系統製造商認證\nCSA A660-10',
        },
      ],
      jzjxList: [
        {
          image: [require('@/components/img/gyhy/ryzs1.jpg')],
          text: '1998華胤廈門\n福建省地産最暢銷産品',
        },
        {
          image: [require('@/components/img/gyhy/ryzs2.jpg')],
          text: '2000年昆山華胤\n上海鋼結構協會金鋼獎',
        },
        {
          image: [require('@/components/img/gyhy/ryzs3.jpg')],
          text: '2001年昆山華胤\n上海鋼結構協會金鋼獎',
        },
        {
          image: [require('@/components/img/gyhy/ryzs4.jpg')],
          text: '2002年上海華胤\n貨運金鋼獎',
        },
        {
          image: [require('@/components/img/gyhy/ryzs5.jpg')],
          text: '2002年上海華胤\n中貨航浦東物流中心金鋼獎',
        },
        {
          image: [require('@/components/img/gyhy/ryzs6.jpg')],
          text: '2003華胤昆山\n創姿服飾金鋼獎',
        },
        {
          image: [require('@/components/img/gyhy/ryzs7.jpg')],
          text: '2003華胤昆山\n惠生科技園金鋼獎證書',
        },
        {
          image: [require('@/components/img/gyhy/ryzs8.jpg')],
          text: '2003上海華胤\n名辰模塑金鋼獎證書',
        },
        {
          image: [require('@/components/img/gyhy/ryzs9.jpg')],
          text: '2004昆山華胤\n嘉麒大廈金鋼獎',
        },
        {
          image: [require('@/components/img/gyhy/ryzs10.jpg')],
          text: '2004昆山華胤\n賽科金鋼獎',
        },
        {
          image: [require('@/components/img/gyhy/ryzs11.jpg')],
          text: '2004廈門華胤\n金鋼獎-同仁堂',
        },
        {
          image: [require('@/components/img/gyhy/ryzs12.jpg')],
          text: '2005華胤集團\n十大傑出企業',
        },
        {
          image: [require('@/components/img/gyhy/ryzs13.jpg')],
          text: '2005華胤集團\n十大影響力品牌',
        },
        {
          image: [require('@/components/img/gyhy/ryzs14.jpg')],
          text: '2005華胤廈門\n金屬結構優秀單位證書',
        },
        {
          image: [require('@/components/img/gyhy/ryzs15.jpg')],
          text: '2005華胤廈門\n閩江杯榮譽證書',
        },
        {
          image: [require('@/components/img/gyhy/ryzs16.jpg')],
          text: '2006華胤昆山\n宜家項目金鋼獎',
        },
        {
          image: [require('@/components/img/gyhy/ryzs17.jpg')],
          text: '2006華胤廈門\nECCO閩江杯',
        },
        {
          image: [require('@/components/img/gyhy/ryzs18.jpg')],
          text: '2006華胤廈門\n福建省先進建築企業榮譽證書',
        },
        {
          image: [require('@/components/img/gyhy/ryzs19.jpg')],
          text: '2006華胤廈門\n福建省著名商標證書',
        },
        {
          image: [require('@/components/img/gyhy/ryzs20.jpg')],
          text: '2006華胤廈門\n福建省著名商標證書',
        },
        {
          image: [require('@/components/img/gyhy/ryzs21.jpg')],
          text: '2006華胤廈門\n專業承包20強',
        },
        {
          image: [require('@/components/img/gyhy/ryzs22.jpg')],
          text: '2007廈門華胤\n專業承包20強',
        },
        {
          image: [require('@/components/img/gyhy/ryzs23.jpg')],
          text: '2008華胤廈門\n福建名牌産品',
        },
        {
          image: [require('@/components/img/gyhy/ryzs24.jpg')],
          text: '2008華胤廈門\n抗震救災先進集體',
        },
        {
          image: [require('@/components/img/gyhy/ryzs25.jpg')],
          text: '2008華胤廈門\n五一勞動獎狀',
        },
        {
          image: [require('@/components/img/gyhy/ryzs26.jpg')],
          text: '蘇州華胤\n港務質量等級證書',
        },
      ],
      gxzList: [
        {
          image: [require('@/components/img/gyhy/gxz1.jpg')],
          text: '1996年蘇州華邦\n高日汽車感謝狀',
        },
        {
          image: [require('@/components/img/gyhy/gxz2.jpg')],
          text: '2001華胤工程\n億光電子感謝狀',
        },
        {
          image: [require('@/components/img/gyhy/gxz3.jpg')],
          text: '2002年華胤廈門\n六和機械感謝狀',
        },
        {
          image: [require('@/components/img/gyhy/gxz4.jpg')],
          text: '2004年華胤昆山\n蘇州鑫端機密感謝狀',
        },
        {
          image: [require('@/components/img/gyhy/gxz5.jpg')],
          text: '2005年華胤昆山\n豐田汽車感謝狀',
        },
        {
          image: [require('@/components/img/gyhy/gxz6.jpg')],
          text: '2005年華胤昆山\n甯波華揚感謝狀',
        },
        {
          image: [require('@/components/img/gyhy/gxz7.jpg')],
          text: 'IBM感謝函',
        },
        {
          image: [require('@/components/img/gyhy/gxz8.jpg')],
          text: '飛鵬鋁業感謝狀',
        },
        {
          image: [require('@/components/img/gyhy/gxz9.jpg')],
          text: 'Fluor\nBASF Jade Tree Project\n“機械竣工紀念”',
        },
        {
          image: [require('@/components/img/gyhy/gxz10.jpg')],
          text: '三菱重工\nThe GPUFP Project\n“感謝獎”',
        },
        {
          image: [require('@/components/img/gyhy/gxz11.jpg')],
          text: 'Fluor\nBASF IOU Project\n“供應商卓越獎”',
        },
        {
          image: [require('@/components/img/gyhy/gxz12.jpg')],
          text: 'Fluor\nBASF Maoming Project\n“供應商卓越獎”',
        },
        {
          image: [require('@/components/img/gyhy/gxz13.jpg')],
          text: 'Fluor\nAlbemarle MSH Project\n“傑出貢獻供應商”',
        },
        {
          image: [require('@/components/img/gyhy/gxz14.jpg')],
          text: 'Turner and Townsend\nStarbucks Kunshan Project\n“安全工時50萬小時”',
        },
        {
          image: [require('@/components/img/gyhy/gxz15.jpg')],
          text: 'Fluor\nBASF Infra Cluster Project\n“安全工作時數三千萬小時”',
        },
        {
          image: [require('@/components/img/gyhy/gxz16.jpg')],
          text: 'Christiaens (China) Production Co., Ltd.\n“25 Tunnels - Phase 23 Project”',
        },
      ],
    }
  },
  methods: {
    // 調用全局方法,滾動指定id
    forId(tId) {
      this.$store.dispatch('toID', tId)
    },
  },
  updated() {
    if (this.scrollToElement) {
      this.scrollToElement()
      this.scrollToElement = null
    }
  },
}
</script>

<style scoped>
/* 榮譽圖片註釋設置 */
.slideImg {
  width: 100%;
  height: 100%;
  margin-bottom: -30px;
  padding-bottom: 30px;
}
.slideP {
  text-align: center;
  color: #000;
  font-size: 16px;
  line-height: 30px;
}

#rzjx,
#gcjs {
  border-top: 1px solid black;
}
.esgImgCon {
  text-align: center;
  margin-top: 0px;
  margin-bottom: 100px;
}
.esgImg {
  width: 70vw;
}

/* 榮譽圖片註釋設置 */
.cbp-spmenu-push {
  overflow-x: hidden;
  position: relative;
  left: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.cbp-spmenu-push .banner {
  background: url(@/components/img/gyhy/1.jpg) 0px 0px no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  height: 500px;
  position: relative;
  width: 100%;
  background-size: 100% 100%;
}

/*-- banner-info --*/
.banner-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.banner-info span {
  font-size: 50px;
  color: #fff;
  padding: 3px 15px;
  margin: 0 auto;
  line-height: normal;
  background: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}

/*-- banner-bottom --*/
.banner-bottom-left p {
  color: #fff;
  font-size: 14px;
  margin: 0;
  line-height: 1.8em;
}
.banner-bottom-left1 {
  border: 5px solid black;
  padding: 8em 5em 5em;
  background: #415160;
}
.banner-bottom-left2 {
  padding: 0;
}
.globe span {
  background: url(@/components/img/gyhy/img-sp.png) no-repeat 22px -81px;
  display: block;
  width: 128px;
  height: 128px;
  border: 1px solid #3f647d;
  border-radius: 100%;
}
.banner-bottom-left1-grid h3 {
  margin: 80px 0 40px;
  color: #fff;
  font-size: 40px;
  text-transform: capitalize;
}
.progress1 {
  height: 2px;
  margin-bottom: 0;
  border-radius: 0;
  margin: 1.5em 0 0;
}
.progress-bar1 {
  background: #eb6f63;
}
.banner-bottom-left1-grid p {
  margin: 40px 0 0;
  color: #fff;
  font-size: 23px;
  line-height: 36px;
}
.banner-bottom-left2 h3 {
  padding: 20px 20px 0;
  font-size: 34px;
  color: #212121;
  margin: 0;
  line-height: 40px;
  position: relative;
}

/*-- effect --*/
.grid {
  position: relative;
  clear: both;
  margin: 0 auto;
  list-style: none;
  text-align: center;
  height: 100%;
}

/* Common style */
.grid figure {
  position: relative;
  float: none;
  margin: 0;
  min-width: 273px;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  text-align: center;
}

.grid figure img {
  position: relative;
  display: block;
  min-height: 100%;
  max-width: 100%;
  width: auto;
  opacity: 0.8;
}

.grid figure figcaption {
  padding: 2em;
  color: #fff;
  text-transform: uppercase;
  font-size: 1.25em;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.grid figure figcaption::before {
  pointer-events: none;
}

.grid figure figcaption,
.grid figure figcaption > a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
/***** Lexi *****/
/*---------------*/

/*-- //effect --*/
/*-- //banner-bottom --*/
/*-- banner-bottom1 --*/
.banner-bottom-lft1 h3 {
  font-size: 5em;
  color: #fff;
  margin: 0;
}
.banner-bottom-left1,
.banner-bottom-lft1 {
  padding: 2.17em 4em 4em;
  /* background: #415160; */
  border-top: 10px double #58c5c8; /* 頂部5px寬的橙色雙線條邊框 */
  border-radius: 10px 10px 0 0; /* 頂部兩角更大的圓角 */
  border-bottom: none; /* 去除底部邊框 */
  border-left: none; /* 去除左邊框 */
  border-right: none; /* 去除右邊框 */

  /* 2. 更精致的背景效果 */
  background: radial-gradient(
    circle,
    #415160 0%,
    #415160 100%
  ); /* 從中心向外的白色到淺灰色漸變背景 */

  /* 4. 文本陰影效果 */
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);

  /* 5. 盒子陰影效果,更立體 */
  box-shadow: 0px -8px 8px -8px rgba(0, 0, 0, 0.2);

  /* 6. 透明度設置 */
  opacity: 0.95;
}
.banner-bottom-lft1 h4 {
  font-size: 40px;
  color: #fff;
  text-align: left;
  margin: 80px 0 40px;
}
.progress2 {
  margin: 1em 0 0;
}
.banner-bottom-lft1 p {
  margin: 40px 0 20px;
  color: #fff;
  font-size: 23px;
  line-height: 36px;
}
h4.with {
  text-align: left;
}

/* 小滾輪 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px !important;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #415160;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 13px;
  text-align: center;
  background: #415160;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #2a2f34;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: 0px;
  left: -205px;
}

#ss_menu div:nth-child(2) {
  top: -62px;
  left: -193px;
}

#ss_menu div:nth-child(3) {
  top: -123px;
  left: -170px;
}

#ss_menu div:nth-child(4) {
  top: -170px;
  left: -123px;
}

#ss_menu div:nth-child(5) {
  top: -193px;
  left: -62px;
}
#ss_menu div:nth-child(6) {
  top: -205px;
  left: 0px;
}

.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

@property --s {
  syntax: '<length>';
  initial-value: 0px;
  inherits: true;
}

.showImg {
  --t: 3px; /* control the thickness (corner = 3*edge) */
  --s: 40px; /* control the size of the corners (that also affect the size of the edges) */
  --g: 8px; /* control the gap */
  --c: #755c3b;

  padding: calc(2 * var(--t) + var(--g));
  border: var(--t) solid #0000;
  background: conic-gradient(
        at var(--s) calc(3 * var(--t)),
        #0000 75%,
        var(--c) 0
      )
      0 0 / calc(100% - var(--s)) calc(100% - 3 * var(--t)) border-box,
    conic-gradient(at calc(3 * var(--t)) var(--s), #0000 75%, var(--c) 0) 0 0 /
      calc(100% - 3 * var(--t)) calc(100% - var(--s)) border-box,
    linear-gradient(0deg, var(--c) calc(2 * var(--t)), #0000 0) 50% var(--t) /
      calc(100% - 2 * (var(--s) + var(--g))) 100% repeat-y padding-box,
    linear-gradient(-90deg, var(--c) calc(2 * var(--t)), #0000 0) var(--t) 50%/100%
      calc(100% - 2 * (var(--s) + var(--g))) repeat-x padding-box;
  transition: --s 0.5s;
  cursor: pointer;
}
.showImg:hover {
  --s: 80px;
}

.rzTop {
  margin: 50px 0;
  text-align: center;
}
.rzTop h1 {
  margin: 50px 0;
}
.rzTop h1 span {
  padding-bottom: 0;
  font-size: 37px;
  font-weight: 900;
}
.rzTop p {
  margin: 0 auto;
  width: 85vw;
  text-align: left;
  font-size: 26px;
  line-height: 40px;
}

.spaceCon {
  margin: 60px auto 0;
}

.gcjsTop {
  margin: 50px 0;
  text-align: center;
}
.gcjsTop h1 {
  margin: 50px 0;
}
.gcjsTop h1 span {
  padding-bottom: 10px;
  font-size: 34px;
  font-weight: 800;
}
.gcjsTop p {
  margin: 0 auto;
  width: 60vw;
  text-align: left;
  font-size: 22px;
  font-weight: 600;
  line-height: 40px;
}
.zzzsHeight {
  height: 100px;
}
.gcjsHeight {
  height: 100px;
}
.jzjxHeight {
  height: 130px;
}
.hover-content h1 {
  font-size: 24px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.onlyPC {
  display: flex;
}

.hspan,
.hspan2 {
  margin: 30px 10px;
  display: inline-block;
  position: relative;
  padding: 10px 20px;
  font-size: 35px;
  font-weight: 600;
}

.gjrzImg,
.jzjxImg {
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}
.gcjsImg {
  position: relative; /* 父容器設為相對定位 */
  width: 100%;
  height: 15vw; /* 按需設置高度 */
  margin: 0;
  text-align: center;
  background-color: #fff;
}
.gcjsp {
  margin: 20px 0;
}
.gcjsp p {
  width: auto;
  text-align: center;
  font-size: 24px;
}

div /deep/ .gjrzImg img {
  padding: 5px;
  width: 100%;
  height: 20vw;
  border: 0;
}

div /deep/ .jzjxImg img {
  padding: 5px;
  width: 100%;
  height: 10vw;
  border: 0;
}

.container-fluid {
  margin: 60px auto 0;
}

/* 漸變背景 */
.gradient-background {
  padding: 0 100px 100px;
  margin-top: 10px;
  border-top: 1px solid #000;
  width: 100%;
  height: 100%; /* 設置高度為視口高度 */
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.mailbg {
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

@media screen and (max-width: 1400px) {
  .grid figure img {
    width: 100%;
  }
  .gradient-background {
    padding: 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .rzTop h1 span {
    padding-bottom: 0;
    font-size: 26px;
    font-weight: 600;
  }
  .rzTop p {
    margin: 0 auto;
    width: 90vw;
    text-align: left;
    font-size: 19px;
    font-weight: 500;
    line-height: 1.5;
  }

  .onlyPC {
    display: inline;
  }
  .container {
    width: 100%;
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan,
  .hspan2 {
    margin: 10px;
    font-size: 22px;
  }
  .gcjsp p {
    width: auto;
    text-align: center;
    font-size: 18px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 10px;
  }
  .gcjsImg {
    height: 30vw;
  }
  .gcjsp {
    margin: 10px 0;
  }
  .gcjsHeight {
    height: 60px;
  }
  div /deep/ .gjrzImg img {
    height: 50vw;
  }
  .hover-content h1 {
    font-size: 18px;
    margin: 10px 0;
  }
  .zzzsHeight {
    height: 80px;
  }
  .container-fluid {
    margin: 20px auto;
  }
  .jzjxHeight {
    height: 100px;
  }
  div /deep/ .jzjxImg img {
    height: 21vw;
  }
  .rzTop {
    margin: 0;
  }
  .row {
    margin: 0 !important;
  }
  .esgImgCon {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .esgImg {
    width: 70vw;
  }
  .banner-info span {
    font-size: 36px;
  }
  .cbp-spmenu-push .banner {
    height: 350px;
  }
  .mobh {
    font-size: 30px !important;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -252px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 26px;
    margin: 40px 0 20px;
  }
  .progress1 {
    margin: 1em 0 0;
  }
  .banner-bottom-left1-grid p {
    margin: 20px 0 10px 0;
    font-size: 19px;
    line-height: 1.5;
  }
  .banner-bottom-left1 {
    padding: 2em;
  }
  .m1 a {
    padding: 0px 80px 10px !important;
  }
  .grid figure figcaption {
    padding: 0em 1em;
  }
  .banner-bottom-left2 h3 {
    font-size: 1em;
    line-height: 1.8em;
  }
  .banner-bottom-lft1 {
    padding: 2em;
  }
  .banner-bottom-lft1 h4 {
    font-size: 26px;
    margin: 40px 0 20px;
  }
  .banner-bottom-lft1 p {
    font-size: 19px;
    line-height: 1.5;
  }
  .equipmentList .equipmentListItem .ListItem .Item h5 {
    font-size: 18px;
  }
}

@media screen and (max-width: 768px) {
  .grid figure img {
    width: auto;
  }
  .gradient-background {
    padding: 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .rzTop h1 span {
    padding-bottom: 0;
    font-size: 20px;
    font-weight: 600;
  }
  .rzTop p {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
  }

  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan,
  .hspan2 {
    margin: 10px;
    font-size: 20px;
  }
  .gcjsp p {
    width: auto;
    text-align: center;
    font-size: 13px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 5px;
  }
  .gcjsImg {
    height: 30vw;
  }
  .gcjsp {
    margin: 10px 0;
  }
  .gcjsHeight {
    height: 40px;
  }
  div /deep/ .gjrzImg img {
    height: 60vw;
  }
  .hover-content h1 {
    font-size: 13px;
    margin: 10px 0;
  }
  .zzzsHeight {
    height: 65px;
  }
  .container-fluid {
    margin: 20px auto;
  }
  .jzjxHeight {
    height: 100px;
  }
  div /deep/ .jzjxImg img {
    height: 21vw;
  }
  .rzTop {
    margin: 0;
  }
  .row {
    margin: 0 !important;
  }
  .esgImgCon {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .esgImg {
    width: 70vw;
  }
  .banner-info span {
    font-size: 30px;
  }
  .cbp-spmenu-push .banner {
    height: 200px;
  }
  .mobh {
    font-size: 30px !important;
  }
  .banner-bottom-left1-grid p {
    margin: 40px 0 20px !important;
    font-size: 12px !important;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -252px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 20px;
    margin: 40px 0 20px;
  }
  .progress1 {
    margin: 1em 0 0;
  }
  .banner-bottom-left1-grid p {
    margin: 20px 0 0;
    font-size: 13px;
    line-height: 22px;
  }
  .banner-bottom-left1 {
    padding: 2em;
  }
  .m1 a {
    padding: 0px 80px 10px !important;
  }
  .grid figure figcaption {
    padding: 0em 1em;
  }
  .banner-bottom-left2 h3 {
    font-size: 1em;
    line-height: 1.8em;
  }
  .banner-bottom-lft1 {
    padding: 1em 1em 2em;
  }
  .banner-bottom-lft1 h4 {
    font-size: 20px;
    margin: 40px 0 20px;
  }
  .banner-bottom-lft1 p {
    font-size: 13px;
    line-height: 22px;
  }
  .equipmentList .equipmentListItem .ListItem .Item h5 {
    font-size: 18px;
  }
}

@media screen and (min-width: 2000px) {
  .banner-bottom-left1-grid p {
    font-size: 29px;
    line-height: 1.8;
  }
  .banner-bottom-left1 {
    padding: 5em;
  }
  .banner-bottom-left1-grid h3 {
    margin: 90px 0 50px;
  }
  .banner-bottom-lft1 h4 {
    margin: 90px 0 50px;
  }
  .banner-bottom-lft1 p {
    font-size: 29px;
    line-height: 1.8;
  }
  .rzTop h1 span {
    font-size: 40px;
  }
  .rzTop p {
    font-size: 29px;
    line-height: 1.8;
  }
  .gradient-background {
    padding: 0 160px 100px;
  }
  .gcjsp p {
    font-size: 26px;
    line-height: 1.5;
  }
  .hover-content h1 {
    font-size: 26px;
    line-height: 1.5;
  }
  .zzzsHeight {
    height: 140px;
  }
  .jzjxHeight {
    height: 140px;
  }
  .banner-info span {
    font-size: 65px;
  }
}
</style>
